// extracted by mini-css-extract-plugin
export default {"hiddenFromScreen":"hiddenFromScreen__7AFk4","lightForeground":"lightForeground__BMQVU"};